module.exports = __webpack_public_path__ + "static/media/32-11.17c01050.mp3";